var _jsxFileName = "/Users/kayote/Documents/ReactApps/fretboard-viz-tool/dependencies/react-fretboard/components/Fretboard/Neck/Position/index.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import pt from 'prop-types';
import { reverse } from 'ramda';
import { transpose } from './../../../../lib/tonal-helpers';
import Wrapper from './Wrapper';
import Fret from './Fret';

const Position = ({
  tuning,
  width,
  pos
}) => /*#__PURE__*/React.createElement(Wrapper, _extends({
  width
}, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 9,
    columnNumber: 3
  }
}), reverse(tuning).map((openNote, str) => {
  const notes_on_fret = reverse(tuning).map(function(e) {
    return transpose(e)(pos)
  });
  const note = transpose(openNote)(pos);
  const loc = {
    str,
    pos
  };
  return /*#__PURE__*/React.createElement(Fret, _extends({
    key: `note-${note}`
  }, {
    note,
    loc,
    notes_on_fret
  }, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 14
    }
  }));
}));

Position.propTypes = {
  tuning: pt.arrayOf(pt.string).isRequired,
  width: pt.number.isRequired,
  pos: pt.number.isRequired
};
export default Position;